export interface ApiError {
  response?: {
    status: number;
    data?: {
      message: string;
      error?: string;
      statusCode?: number;
    };
  };
  isPermissionDenied?: boolean;
  message?: string;
}

export const getErrorMessage = (error: any): string => {
  if (error?.isPermissionDenied || error?.response?.status === 403) {
    const message = error?.response?.data?.message || 'Access denied';
    return `Permission Error: ${message}. You need admin privileges to perform this action.`;
  }
  
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }
  
  if (error?.message) {
    return error.message;
  }
  
  return 'An unexpected error occurred';
};

export const isPermissionError = (error: any): boolean => {
  return error?.isPermissionDenied || error?.response?.status === 403;
};